import {
    Accordion,
    ActionIcon,
    Badge,
    Box,
    Button,
    Center,
    Collapse,
    createStyles,
    Divider,
    Group,
    Loader,
    MultiSelect,
    NativeSelect,
    ScrollArea,
    SegmentedControl,
    Select,
    Stack,
    Text,
    TextInput,
    ThemeIcon,
    Title,
    UnstyledButton,
    useMantineTheme,
} from '@mantine/core';
import { IconCamera, IconCapture, IconChevronDown, IconChevronRight, IconFilter, IconFlag2, IconFlag2Off, IconPhoto, IconSearch, IconX } from '@tabler/icons-react';
import { VariableSizeList as List } from 'react-window';
import { ColourTag, FormInputWrapper, StarRating, TagInput } from 'core/components/index';

import { logger } from 'utils/logger';
import moment from 'moment';
import { FlagRating, SessionTypes } from 'utils/constants';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import SessionSelect from 'core/components/sessionSelect/SessionSelect';
import { useDispatch } from 'react-redux';
import { getStyles } from '../approvalSlice';
import { getSessions } from 'services/sessionService';
import { headerDateSort, matchesKeywords } from 'utils/helper';

const useStyles = createStyles((theme, _params, getRef) => ({
    keywordSearch: {
        input: {
            paddingRight: 67,
        },
        span: {
            fontSize: 10,
        },
        '.mantine-Input-rightSection': {
            width: 67,
        },
    },
    captureMenuItem: {
        marginLeft: theme.spacing.xl * 1.2,
        flexGrow: '1 !important',
        borderRadius: theme.radius.xs,
        paddingTop: theme.spacing.xs / 3,
        paddingBottom: theme.spacing.xs / 3,
        paddingLeft: theme.spacing.xs,
        // width:'100%',
        '&:hover': {
            backgroundColor: theme.colors.dark[4],
        },
        '&.selected': {
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[4],
            color: theme.colors.brand[4],
        },
    },
    accordians: {
        '.row': {},
    },
}));

const FilterPanel = ({ approvalFilter, onCollectionClick, form, aggData, onSubmit, onClearClick, isSearching, styles = [], sessions = [], scrollToTarget }) => {
    const { classes } = useStyles();
    const LABEL_WIDTH = '80px';
    const [tags, setTags] = useState([]);
    const dispatch = useDispatch();
    const [keyword, setKeyword] = useState('');
    const [filteredStyles, setFilteredStyles] = useState([styles]);
    const [formState, setFormState] = useState(false);

    const clearFilter = () => {
        logger.log('clear click');
        onClearClick();
    };

    const theme = useMantineTheme();

    useEffect(() => {
        if (keyword) {
            setFilteredStyles(
                styles.filter((val) => {
                    return matchesKeywords(keyword, val.name, val.targetSort);
                }),
            );
        } else {
            setFilteredStyles(styles);
        }
    }, [keyword, styles]);

    const onChangeHandler = (field, value) => {
        form.setFieldValue(field, value);

        // update form state
        setTimeout(() => {
            setFormState(Math.random());
        }, 10);
    };

    useEffect(() => {
        if (formState) {
            onSubmit(form.values);
        }
    }, [formState]);

    return (
        <Accordion multiple className='unhightable' defaultValue={['filters']}>
            {/* <Accordion.Item value='captures'>
                <Accordion.Control>
                    <Group>
                        <IconCamera />
                        <Title order={6} className='unhightable'>
                            Catalogues
                        </Title>
                    </Group>
                </Accordion.Control>
                <Accordion.Panel>
                    <CollectionMenu classes={classes} onItemClick={(e) => onCollectionClick(e)} selectedItem={approvalFilter.catalogue} />
                </Accordion.Panel>
            </Accordion.Item> */}

            <Accordion.Item value='filters'>
                <Accordion.Control>
                    <Group>
                        <IconFilter></IconFilter>
                        <Title order={6} className='unhightable'>
                            Filters
                        </Title>
                    </Group>
                </Accordion.Control>
                <Accordion.Panel pl={'xs'} className={classes.accordians}>
                    {/* <FormInputWrapper label='Client' labelWidth={LABEL_WIDTH} required>
                        {aggData && aggData.clients?<Select required placeholder='All Clients' {...form.getInputProps('client')} data={aggData?.clients?.map((val) => ({ label: val.name, value: val.code }))} />:null}
                    </FormInputWrapper> */}
                    <Box>
                        {/* create a tree component  */}
                        <TreeComponent
                            sessions={sessions || []}
                            styles={styles}
                            selectedSessionId={form.values.sessionId}
                            selectedStyleNumber={form.values.styleNumber}
                            onSessionChange={(val) => onChangeHandler('sessionId', val)}
                            onStyleChange={(val) => onChangeHandler('styleNumber', val)}
                            keyword={keyword}
                            scrollToTarget={scrollToTarget}
                        />
                    </Box>

                    <FormInputWrapper label='Flag' id='input-status' labelWidth={LABEL_WIDTH}>
                        <SegmentedControl
                            value={form.values.sak}
                            // {...form.getInputProps('sak')}
                            onChange={(val) => onChangeHandler('sak', val)}
                            data={[
                                {
                                    value: FlagRating.FLAG_SELECT,
                                    label: (
                                        <Center sx={{ height: 18 }}>
                                            <IconFlag2 size={16} />
                                            {/* <Box ml={10}>Preview</Box> */}
                                        </Center>
                                    ),
                                },
                                {
                                    value: FlagRating.FLAG_KILL,
                                    label: (
                                        <Center sx={{ height: 18 }}>
                                            <IconFlag2Off size={16} />
                                            {/* <Box ml={10}>Code</Box> */}
                                        </Center>
                                    ),
                                },
                                {
                                    value: '-1',
                                    label: (
                                        <Center>
                                            <Box ml={0}>
                                                <Text size={'xs'}>All</Text>
                                            </Box>
                                        </Center>
                                    ),
                                },
                            ]}
                        />
                        {/* <FlagToggle /> */}
                    </FormInputWrapper>

                    <FormInputWrapper label='Rating' id='input-rating' labelWidth={LABEL_WIDTH} labelPosition='center'>
                        <Group mt={5}>
                            <StarRating onChange={(val) => {
                                logger.log('val', val, form.values.star)
                                // if the value is the same as the current value, set it to -1
                                if (val === parseInt(form.values.star)) {
                                    onChangeHandler('star', -1)
                                } else {
                                    onChangeHandler('star', val)
                                }
                            }} rating={form.values.star} />
                        </Group>
                        <Group>
                            {/* <NativeSelect
                  data={['=', '<', '>', '<=', '>=']}
                /> */}
                            {/* <Rating defaultValue={0} color={'lime'} /> */}
                            {/* <StarRating /> */}
                        </Group>
                    </FormInputWrapper>

                    <FormInputWrapper label='Colour Tag' id='input-colourTag' labelWidth={LABEL_WIDTH}>
                        <Group mt='xs'>
                            <ColourTag
                                layout='inline'
                                onColourChange={(val) => {
                                    // need to check if the value is already in the array if it is remove it else add it
                                    if (form.values.colourTag.indexOf(val) === -1) {
                                        onChangeHandler('colourTag', [...form.values.colourTag, val]);
                                    } else {
                                        onChangeHandler(
                                            'colourTag',
                                            form.values.colourTag.filter((item) => item !== val),
                                        );
                                    }
                                }}
                                selectedValues={form.values.colourTag}
                            />
                        </Group>
                    </FormInputWrapper>
                    <Group mt={'xl'} sx={{ width: '100%' }}>
                        <Button variant='outline' fullWidth onClick={() => clearFilter()}>
                            Clear Filters
                        </Button>
                    </Group>
                    {/* <FormInputWrapper label='Session' id='input-session' labelWidth={LABEL_WIDTH} direction='column'>
                        <SessionSelect onChange={(val) => onChangeHandler('sessionId', val)} value={form.values.sessionId} />
              </FormInputWrapper> */}
                </Accordion.Panel>
            </Accordion.Item>
        </Accordion>
    );
};

export default FilterPanel;

const CollectionMenu = ({ classes, selectedItem, onItemClick }) => {
    const collections = [
        { label: 'Latest', value: { since: null, until: null } },
        { label: 'Today', value: { since: moment().hour(0).minute(0).format('YYYY-MM-DD-HH-mm-ss-SSS'), until: moment().format('YYYY-MM-DD-HH-mm-ss-SSS') } },
        { label: 'This Week', value: { since: moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD-HH-mm-ss-SSS'), until: moment().format('YYYY-MM-DD-HH-mm-ss-SSS') } },
        { label: 'This Month', value: { since: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD-HH-mm-ss-SSS'), until: moment().format('YYYY-MM-DD-HH-mm-ss-SSS') } },
        { label: 'This Year', value: { since: moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD-HH-mm-ss-SSS'), until: moment().format('YYYY-MM-DD-HH-mm-ss-SSS') } },
        {
            label: 'Last Week',
            value: { since: moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD-HH-mm-ss-SSS'), until: moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD-HH-mm-ss-SSS') },
        },
        {
            label: 'Last Month',
            value: { since: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD-HH-mm-ss-SSS'), until: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD-HH-mm-ss-SSS') },
        },
        {
            label: 'Last Year',
            value: { since: moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD-HH-mm-ss-SSS'), until: moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD-HH-mm-ss-SSS') },
        },
    ];

    const getClassName = (val = '') => {
        var cls = val.label === selectedItem.label ? `${classes.captureMenuItem} selected` : classes.captureMenuItem;
        return cls;
    };

    return (
        <>
            <Group sx={{ flexDirection: 'column', alignContent: 'start', flexWrap: 'nowrap', alignItems: 'stretch', gap: 0 }} ml='lg'>
                <UnstyledButton className={getClassName('')} sx={{ marginLeft: 0 }} onClick={() => onItemClick(null)}>
                    <Group spacing={'xs'}>
                        <IconCapture size={14} />
                        <Text size={'sm'}>All Captures</Text>
                    </Group>
                </UnstyledButton>
            </Group>
            <Group sx={{ flexDirection: 'column', alignContent: 'start', flexWrap: 'nowrap', alignItems: 'stretch', gap: 0 }} ml='lg'>
                {collections.map((val, idx) => {
                    return (
                        <UnstyledButton key={idx} className={getClassName(val)} onClick={() => onItemClick(val)}>
                            <Group spacing={'xs'}>
                                <IconChevronRight size={14} />
                                <Text size={'sm'}>{val.label}</Text>
                            </Group>
                        </UnstyledButton>
                    );
                })}
            </Group>
        </>
    );
};

// Custom hook for sticky headers in virtualized list
const useStickyHeaders = (flattenedItems) => {
    const [currentStickyHeader, setCurrentStickyHeader] = useState(null);
    const listRef = useRef(null);

    const handleScroll = useCallback(
        ({ scrollDirection, scrollOffset, scrollUpdateWasRequested }) => {
            const scrollTop = scrollOffset;

            if (!flattenedItems.length || scrollTop === undefined) return;

            // Find which header should be sticky based on scroll position
            let activeHeader = null;
            let cumulativeHeight = 0;
            let sessionHeaders = [];

            // First, collect all session positions
            for (let i = 0; i < flattenedItems.length; i++) {
                const item = flattenedItems[i];
                const itemHeight = item?.type === 'session' ? 65 : 65;

                if (item.type === 'session') {
                    sessionHeaders.push({
                        item,
                        index: i,
                        startPosition: cumulativeHeight,
                        endPosition: cumulativeHeight + itemHeight,
                    });
                }

                cumulativeHeight += itemHeight;
            }

            // Find the active sticky header - work backwards to find the current session
            for (let j = sessionHeaders.length - 1; j >= 0; j--) {
                const currentSession = sessionHeaders[j];
                const nextSession = sessionHeaders[j + 1];

                const sessionHeaderHeight = 65;
                const sessionHeaderEnd = currentSession.startPosition + sessionHeaderHeight - sessionHeaderHeight;

                // Calculate where this session's content ends (before next session starts)
                const sessionContentEnd = nextSession ? nextSession.startPosition : cumulativeHeight;

                // Check if this session has expanded styles by looking at the gap between sessions
                const hasExpandedStyles = sessionContentEnd > sessionHeaderEnd + sessionHeaderHeight;

                // Show sticky header when:
                // 1. We've scrolled past the session header
                // 2. The session has expanded styles
                // 3. We're still within this session's content area
                // Working backwards ensures we get the last/current session
                if (scrollTop >= sessionHeaderEnd && hasExpandedStyles && scrollTop < sessionContentEnd && hasExpandedStyles) {
                    activeHeader = {
                        item: currentSession.item,
                        index: currentSession.index,
                        isVisible: true,
                    };
                    break; // Found the active session, stop looking
                }
            }

            setCurrentStickyHeader(activeHeader);
        },
        [flattenedItems],
    );

    return { currentStickyHeader, listRef, handleScroll };
};

const TreeComponent = ({ styles, selectedSessionId, selectedStyleNumber, onSessionChange, onStyleChange, sessions = [], scrollToTarget }) => {
    const theme = useMantineTheme();
    const [expandedSessions, setExpandedSessions] = useState(new Set());
    const [sessionData, setSessionData] = useState([]);
    // const [accumulatedStyles, setAccumulatedStyles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [styleMap, setStyleMap] = useState(new Map());
    const [sessionLoadingMap, setSessionLoadingMap] = useState(new Map());
    const [flattenedItems, setFlattenedItems] = useState([]);
    const [stickyHeaders, setStickyHeaders] = useState([]);

    const [keyword, setKeyword] = useState('');

    useEffect(() => {
        const sortedSessions = sessions.sort((a, b) => headerDateSort({ values: { created: b.created } }, { values: { created: a.created } }, 'created'));

        const allSessions = [...sortedSessions];
        setSessionData(allSessions);

        // Set default selection to first session with styles
        if (!selectedSessionId && sortedSessions.length > 0) {
            // if (firstSessionWithStyles) {
            //     const sessionStyles = accumulatedStyles.filter(style => style.sessionId === firstSessionWithStyles.id);
            //     const sessionIdValue = `session|${firstSessionWithStyles.id}`;

            //     onSessionChange(sessionIdValue);
            //     if (sessionStyles.length > 0) {
            //         onStyleChange(sessionStyles[0].targetSort);
            //     }

            //     // Expand the first session
            //     setExpandedSessions(new Set([firstSessionWithStyles.id]));
            // }
            onSessionChange(allSessions[0].id);
        }
    }, [sessions]);
    const toggleSession = (sessionId) => {
        const newExpanded = new Set(expandedSessions);
        if (newExpanded.has(sessionId)) {
            newExpanded.delete(sessionId);
        } else {
            newExpanded.add(sessionId);
        }
        setExpandedSessions(newExpanded);
    };
    // Helper function to highlight matching text
    const highlightText = useCallback((text, searchTerm) => {
        if (!searchTerm.trim() || !text) return text;

        const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
        const parts = text.split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span key={index} style={{ backgroundColor: theme.colorScheme === 'dark' ? theme.colors.yellow[3] : theme.colors.yellow[3], color: 'black', fontWeight: 'bold' }}>
                    {part}
                </span>
            ) : (
                part
            ),
        );
    }, []);

    const { currentStickyHeader, listRef, handleScroll } = useStickyHeaders(flattenedItems);

    // Animated scroll function
    const animatedScrollTo = useCallback((targetScrollTop, duration = 500) => {
        if (!listRef.current) return;

        const startScrollTop = listRef.current.state.scrollOffset || 0;
        const distance = targetScrollTop - startScrollTop;
        const startTime = performance.now();

        const animateScroll = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // Easing function (ease-out)
            const easeOut = 1 - Math.pow(1 - progress, 3);
            const currentScrollTop = startScrollTop + distance * easeOut;

            if (listRef.current) {
                listRef.current.scrollTo(currentScrollTop);
            }

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            }
        };

        requestAnimationFrame(animateScroll);
    }, []);

    // Function to scroll to a particular session
    const scrollToSession = useCallback(
        (sessionId) => {
            if (!listRef.current || !flattenedItems.length) {
                return;
            }

            // Find the index of the session in flattenedItems using id
            const sessionIndex = flattenedItems.findIndex((item) => item.type === 'session' && item.data.id === sessionId);

            if (sessionIndex !== -1) {
                // Clear any keyword filter that might be hiding the session
                if (keyword.trim()) {
                    setKeyword('');

                    // Wait for the filter to clear and then scroll
                    setTimeout(() => {
                        const newSessionIndex = flattenedItems.findIndex((item) => item.type === 'session' && item.data.id === sessionId);
                        if (newSessionIndex !== -1 && listRef.current) {
                            // Force the list to re-render and then animate scroll
                            listRef.current.resetAfterIndex(0);
                            requestAnimationFrame(() => {
                                const itemHeight = 65; // Each item is 65px
                                const targetScrollTop = newSessionIndex * itemHeight;
                                animatedScrollTo(targetScrollTop, 800);
                            });
                        }
                    }, 100);
                } else {
                    // Reset the list cache and animate scroll
                    listRef.current.resetAfterIndex(0);

                    // Use requestAnimationFrame to ensure the list is ready
                    requestAnimationFrame(() => {
                        if (listRef.current) {
                            const itemHeight = 65; // Each item is 65px
                            const targetScrollTop = sessionIndex * itemHeight;
                            animatedScrollTo(targetScrollTop, 800);
                        }
                    });
                }

                // Optionally expand the session if it has styles
                const session = flattenedItems[sessionIndex].data;
                if (styleMap.has(session.id) && !expandedSessions.has(session.id)) {
                    toggleSession(session.id);
                }
            } else {
                // If session not found, it might be filtered out. Clear filters and try again.
                const sessionInData = sessionData.find((s) => s.id === sessionId);
                if (sessionInData) {
                    setKeyword('');

                    // Wait for re-render and try again
                    setTimeout(() => {
                        const retryIndex = flattenedItems.findIndex((item) => item.type === 'session' && item.data.id === sessionId);
                        if (retryIndex !== -1 && listRef.current) {
                            // Use virtualization-aware animated scrolling for retry
                            listRef.current.resetAfterIndex(0);
                            requestAnimationFrame(() => {
                                const itemHeight = 65;
                                const targetScrollTop = retryIndex * itemHeight;
                                animatedScrollTo(targetScrollTop, 800);
                            });
                        }
                    }, 200);
                }
            }
        },
        [flattenedItems, styleMap, expandedSessions, toggleSession, sessionData, keyword, setKeyword, animatedScrollTo],
    );

    // Function to scroll to a particular style within a session
    const scrollToStyle = useCallback(
        (sessionId, styleTargetSort) => {
            if (!listRef.current || !flattenedItems.length) return;

            // First ensure the session is expanded
            if (!expandedSessions.has(sessionId)) {
                toggleSession(sessionId);

                // Wait for the next render cycle after expansion
                setTimeout(() => {
                    // Find the style index after expansion
                    const styleIndex = flattenedItems.findIndex((item) => item.type === 'style' && item.sessionId === sessionId && item.data.targetSort === styleTargetSort);

                    if (styleIndex !== -1) {
                        const itemHeight = 65;
                        const containerHeight = listRef.current.props.height;
                        const targetScrollTop = styleIndex * itemHeight - containerHeight / 2 + itemHeight / 2;
                        animatedScrollTo(Math.max(0, targetScrollTop), 600);
                    }
                }, 100);
            } else {
                // Session is already expanded, find and scroll to style
                const styleIndex = flattenedItems.findIndex((item) => item.type === 'style' && item.sessionId === sessionId && item.data.targetSort === styleTargetSort);

                if (styleIndex !== -1) {
                    const itemHeight = 65;
                    const containerHeight = listRef.current.props.height;
                    const targetScrollTop = styleIndex * itemHeight - containerHeight / 2 + itemHeight / 2;
                    animatedScrollTo(Math.max(0, targetScrollTop), 600);
                }
            }
        },
        [flattenedItems, expandedSessions, toggleSession, animatedScrollTo],
    );

    // Handle scroll requests from parent
    useEffect(() => {
        logger.log('scrollToTarget', scrollToTarget);
        if (!scrollToTarget) return;

        if (scrollToTarget.sessionId) {
            scrollToSession(scrollToTarget.sessionId);
        }

        if (scrollToTarget.styleNumber && scrollToTarget.sessionId) {
            // scroll to the style
            setTimeout(() => {
                scrollToStyle(scrollToTarget.sessionId, scrollToTarget.styleNumber);
            }, 500);
        }
    }, [scrollToTarget]);

    useEffect(() => {
        // Accumulate styles from different sessions as they are loaded
        if (styles && styles.length > 0) {
            // add the styles to the style map with the sessionId as the key
            setStyleMap((prevMap) => {
                const newMap = new Map(prevMap);
                newMap.set(selectedSessionId, styles);
                return newMap;
            });

            setSessionLoadingMap((prevMap) => {
                const newMap = new Map(prevMap);
                newMap.set(selectedSessionId, false);
                return newMap;
            });
            // setAccumulatedStyles(prevStyles => {
            // Create a map to avoid duplicates based on style.targetSort and sessionId
            // setStyleMap(new Map());

            // Add existing styles to map

            // return Array.from(styleMap.values());
            // });
        }
    }, [styles]);

    // useEffect(() => {
    //     const getData = async () => {
    //         try {

    //             // Add default options
    //             const defaultOptions = [
    //                 // {
    //                 //     id: '',
    //                 //     code: 'ALL',
    //                 //     name: 'All Sessions',
    //                 //     isDefault: true
    //                 // },
    //                 // {
    //                 //     id: SessionTypes.UNKOWN,
    //                 //     code: '00',
    //                 //     name: 'Unassigned',
    //                 //     isDefault: true
    //                 // }
    //             ];

    //             const sortedSessions = sessionsData.sort((a, b) => headerDateSort({ values: { created: b.created } }, { values: { created: a.created } }, 'created'));

    //             const allSessions = [...defaultOptions, ...sortedSessions];
    //             setSessionData(allSessions);

    //             // Set default selection to first session with styles
    //             if (!selectedSessionId && sortedSessions.length > 0) {
    //                 // if (firstSessionWithStyles) {
    //                 //     const sessionStyles = accumulatedStyles.filter(style => style.sessionId === firstSessionWithStyles.id);
    //                 //     const sessionIdValue = `session|${firstSessionWithStyles.id}`;

    //                 //     onSessionChange(sessionIdValue);
    //                 //     if (sessionStyles.length > 0) {
    //                 //         onStyleChange(sessionStyles[0].targetSort);
    //                 //     }

    //                 //     // Expand the first session
    //                 //     setExpandedSessions(new Set([firstSessionWithStyles.id]));
    //                 // }
    //                 onSessionChange(sessionData[0]);
    //             }

    //             setIsLoading(false);
    //         } catch (error) {
    //             logger.error('Error fetching sessions:', error);
    //             setIsLoading(false);
    //         }
    //     };

    //     getData();
    // }, []);

    const handleSessionClick = (session) => {
        setSessionLoadingMap((prevMap) => {
            const newMap = new Map(prevMap);
            newMap.set(session.id, true);
            return newMap;
        });

        onSessionChange(session.id);

        // Clear style selection when changing session
        onStyleChange('');

        // Expand/collapse session if it has styles
        if (!session.isDefault) {
            toggleSession(session.id);
        }
    };

    const handleStyleClick = (style, sessionId) => {
        // Set both session and style
        const sessionValue = `${sessionId}`;
        onSessionChange(sessionValue);
        onStyleChange(style.targetSort);
    };

    const getSessionStyles = (sessionId) => {
        return styleMap.get(sessionId);
    };

    // Filter function for sessions and styles
    const filterSessionsAndStyles = useCallback(
        (sessions, keyword) => {
            if (!keyword.trim()) return sessions;

            return sessions.filter((session) => {
                // Check if session matches
                const sessionMatch = matchesKeywords(keyword, session.code, session.name, session.description);

                // Check if any of the session's styles match
                let hasMatchingStyles = false;
                if (styleMap.has(session.id)) {
                    const sessionStyles = styleMap.get(session.id);
                    hasMatchingStyles = sessionStyles.some(
                        (style) => matchesKeywords(keyword, style.targetSort, style.name, style.stylenumber, style.id),
                    );
                }

                return sessionMatch || hasMatchingStyles;
            });
        },
        [styleMap],
    );

    // Filter styles within a session
    const filterStylesInSession = useCallback((styles, keyword) => {
        if (!keyword.trim()) return styles;

        return styles.filter(
            (style) => matchesKeywords(keyword, style.targetSort, style.name, style.stylenumber, style.id),
        );
    }, []);

    // Check if session itself matches the keyword
    const sessionMatches = useCallback((session, keyword) => {
        if (!keyword.trim()) return false;
        return matchesKeywords(keyword, session.code, session.name, session.description);
    }, []);

    // Auto-expand sessions that match or have matching styles when searching
    useEffect(() => {
        if (keyword.trim()) {
            const newExpanded = new Set(expandedSessions);
            let hasChanges = false;

            sessionData.forEach((session) => {
                // Expand if session itself matches
                const sessionMatchesKeyword = sessionMatches(session, keyword);

                // Or if any of its styles match
                let hasMatchingStyles = false;
                if (styleMap.has(session.id)) {
                    const sessionStyles = styleMap.get(session.id);
                    hasMatchingStyles = sessionStyles.some(
                        (style) => matchesKeywords(keyword, style.targetSort, style.name, style.stylenumber, style.id),
                    );
                }

                if ((sessionMatchesKeyword || hasMatchingStyles) && !newExpanded.has(session.id)) {
                    newExpanded.add(session.id);
                    hasChanges = true;
                }
            });

            if (hasChanges) {
                setExpandedSessions(newExpanded);
            }
        }
    }, [keyword, sessionData, styleMap, expandedSessions, sessionMatches]);

    // Flatten the tree structure for virtualization with filtering
    useEffect(() => {
        const items = [];
        const headers = [];

        // Apply keyword filtering to sessions
        const filteredSessions = filterSessionsAndStyles(sessionData, keyword);

        filteredSessions.forEach((session, sessionIndex) => {
            // Track session headers for sticky positioning
            headers.push({
                index: items.length,
                sessionId: session.id,
                session: session,
            });

            // Add session item
            items.push({
                type: 'session',
                data: session,
                id: `session-${session.id}`,
                level: 0,
                isHeader: true,
            });

            // Add styles if session is expanded
            if (expandedSessions.has(session.id) && styleMap.has(session.id)) {
                const sessionStyles = styleMap.get(session.id);

                // If session itself matches, show ALL styles
                // Otherwise, only show matching styles
                const stylesToShow = sessionMatches(session, keyword) ? sessionStyles : filterStylesInSession(sessionStyles, keyword);

                stylesToShow.forEach((style) => {
                    items.push({
                        type: 'style',
                        data: style,
                        sessionId: session.id,
                        id: `style-${session.id}-${style.targetSort}`,
                        level: 1,
                        isHeader: false,
                    });
                });
            }
        });

        setFlattenedItems(items);
        setStickyHeaders(headers);
    }, [sessionData, expandedSessions, styleMap, keyword, filterSessionsAndStyles, filterStylesInSession, sessionMatches]);

    const isSessionSelected = (session) => {
        logger.log(session.id, selectedSessionId);
        if (session.isDefault) {
            return selectedSessionId === session.id;
        }
        return selectedSessionId === session.id;
    };

    const isStyleSelected = (style) => {
        return selectedStyleNumber === style.targetSort;
    };

    // Row renderer for virtualized list
    const Row = React.memo(({ index, style }) => {
        const item = flattenedItems[index];

        if (!item) return null;

        if (item.type === 'session') {
            const session = item.data;
            const sessionStyles = getSessionStyles(session.id);
            const hasStyles = styleMap.has(session.id);
            const isExpanded = expandedSessions.has(session.id);
            const isSelected = isSessionSelected(session);

            return (
                <div
                    style={{
                        ...style,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderBottom: theme.colorScheme === 'dark' ? `1px solid ${theme.colors.dark[5]}` : `1px solid ${theme.colors.gray[2]}`,
                    }}>
                    <UnstyledButton
                        onClick={() => handleSessionClick(session)}
                        sx={{
                            display: 'block',
                            width: '100%',
                            height: 64,
                            padding: theme.spacing.xs,

                            backgroundColor: isSelected
                                ? theme.colorScheme === 'dark'
                                    ? theme.colors.brand[6]
                                    : theme.colors.brand[2]
                                : theme.colorScheme === 'dark'
                                ? theme.colors.dark[7]
                                : theme.white,
                            '&:hover': {
                                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1],
                            },
                            color: isSelected ? (theme.colorScheme === 'dark' ? theme.white : theme.colors.gray[9]) : 'inherit',
                        }}>
                        <Group spacing='xs' noWrap>
                            <div style={{ width: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                {hasStyles && !session.isDefault ? (
                                    <ThemeIcon
                                        size='sm'
                                        variant='transparent'
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleSession(session.id);
                                        }}>
                                        {isExpanded ? <IconChevronDown size={14} /> : <IconChevronRight size={14} />}
                                    </ThemeIcon>
                                ) : (
                                    <IconChevronRight size={14} />
                                )}
                            </div>
                            <Box sx={{ flex: 1 }}>
                                <div>
                                    <Text weight={isSelected ? 600 : 400} size='sm'>
                                        {highlightText(session.code, keyword)}
                                    </Text>
                                    <Text size='xs' truncate sx={{ width: 200 }} opacity={0.65}>
                                        {highlightText(session.name, keyword)}
                                    </Text>
                                </div>
                            </Box>

                            {/* if fetching styles show loader */}
                            {sessionLoadingMap.get(session.id) && <Loader variant='dots' size='sm' />}
                            {hasStyles && (
                                <Badge size='sm' variant='outline'>
                                    {sessionStyles?.length || 0}
                                </Badge>
                            )}
                        </Group>
                    </UnstyledButton>
                </div>
            );
        }

        if (item.type === 'style') {
            const styleData = item.data;
            const isStyleSelectedState = isStyleSelected(styleData);

            return (
                <div
                    style={{
                        ...style,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: 65,
                        borderBottom: theme.colorScheme === 'dark' ? `1px solid ${theme.colors.dark[6]}` : `1px solid ${theme.colors.gray[2]}`,
                    }}>
                    <UnstyledButton
                        pl={45}
                        onClick={() => handleStyleClick(styleData, item.sessionId)}
                        sx={{
                            display: 'block',
                            width: '100%',
                            height: 63,
                            padding: `${theme.spacing.xs / 2}px ${theme.spacing.xs}px`,
                            paddingLeft: 50,
                            backgroundColor: isStyleSelectedState ? (theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white) : 'transparent',
                            '&:hover': {
                                backgroundColor: isStyleSelectedState
                                    ? theme.colorScheme === 'dark'
                                        ? theme.colors.dark[6]
                                        : theme.colors.gray[0]
                                    : theme.colorScheme === 'dark'
                                    ? theme.colors.dark[6]
                                    : theme.colors.gray[0],
                            },
                            color: isStyleSelectedState ? (theme.colorScheme === 'dark' ? theme.white : theme.colors.gray[9]) : 'inherit',
                            borderLeft: isStyleSelectedState ? (theme.colorScheme === 'dark' ? `2px solid ${theme.colors.brand[6]}` : `2px solid ${theme.colors.brand[3]}`) : 'none',
                        }}>
                        <Group position='apart' noWrap spacing={'md'}>
                            <Box>
                                <Text size='sm' weight={isStyleSelectedState ? 600 : 400}>
                                    {highlightText(styleData.targetSort, keyword)}
                                </Text>
                                <Text size='xs' opacity={0.65} truncate sx={{ maxWidth: 170 }}>
                                    {highlightText(styleData.name, keyword)}
                                </Text>
                            </Box>
                            {styleData.captures && (
                                <Badge size='sm' variant='light' opacity={styleData.captures.length ? 1 : 0.5}>
                                    <Group spacing={4}>
                                        <IconCamera size={14} />
                                        {styleData.captures.length ? styleData.captures.length : '0'}
                                    </Group>
                                </Badge>
                            )}
                        </Group>
                    </UnstyledButton>
                </div>
            );
        }

        return null;
    });

    // Sticky header component
    const StickyHeader = () => {
        if (!currentStickyHeader) return null;

        const session = currentStickyHeader.item.data;
        const sessionStyles = getSessionStyles(session.id);
        const hasStyles = styleMap.has(session.id);
        const isExpanded = expandedSessions.has(session.id);
        const isSelected = isSessionSelected(session);

        return (
            <div
                style={{
                    position: 'absolute',
                    top: 72, // TextInput (36px) + debug text with padding (24px)
                    left: 0,
                    right: 0,
                    height: 65,
                    zIndex: 1000,
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.brand[2],
                    borderBottom: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.brand[2]}`,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    pointerEvents: 'auto',
                }}>
                <UnstyledButton
                    onClick={() => handleSessionClick(session)}
                    sx={{
                        display: 'block',
                        width: '100%',
                        height: 63,
                        padding: theme.spacing.xs,
                        backgroundColor: isSelected
                            ? theme.colorScheme === 'dark'
                                ? theme.colors.brand[6]
                                : theme.colors.brand[2]
                            : theme.colorScheme === 'dark'
                            ? theme.colors.dark[7]
                            : theme.white,
                        '&:hover': {
                            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1],
                        },
                        color: isSelected ? (theme.colorScheme === 'dark' ? theme.white : theme.colors.gray[9]) : 'inherit',
                    }}>
                    <Group spacing='xs' noWrap>
                        <div style={{ width: 22 }}>
                            {hasStyles && !session.isDefault ? (
                                <ActionIcon
                                    size='sm'
                                    variant='transparent'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleSession(session.id);
                                    }}>
                                    {isExpanded ? <IconChevronDown size={14} /> : <IconChevronRight size={14} />}
                                </ActionIcon>
                            ) : (
                                <IconChevronRight size={14} />
                            )}
                        </div>
                        <Box sx={{ flex: 1 }}>
                            <div>
                                <Text weight={isSelected ? 600 : 400} size='sm'>
                                    {highlightText(session.code, keyword)}
                                </Text>
                                <Text size='xs' truncate sx={{ width: 200 }} opacity={0.65}>
                                    {highlightText(session.name, keyword)}
                                </Text>
                            </div>
                        </Box>

                        {hasStyles && (
                            <Badge size='sm' variant='outline'>
                                {sessionStyles?.length || 0}
                            </Badge>
                        )}
                    </Group>
                </UnstyledButton>
            </div>
        );
    };

    if (isLoading) {
        return (
            <Text size='sm' color='dimmed'>
                Loading sessions... {flattenedItems.length}
            </Text>
        );
    }

    return (
        <Box
            sx={{
                border: theme.colorScheme === 'dark' ? `1px solid ${theme.colors.dark[5]}` : `1px solid ${theme.colors.gray[2]}`,
                borderRadius: theme.radius.sm,
                position: 'relative',
            }}>
            <Box w='100%'>
                <TextInput
                    rightSection={
                        <ActionIcon opacity={keyword ? 1 : 0} onClick={() => setKeyword('')}>
                            <IconX size={14} />
                        </ActionIcon>
                    }
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    sx={{
                        width: '100%',
                        input: {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                            border: 0,
                            borderBottomWidth: 1,
                            borderBottomStyle: 'solid',
                            borderBottomColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2],
                        },
                    }}
                    placeholder='Filter Sessions...'
                    icon={<IconSearch size={14} />}
                />
            </Box>
            {/* Debug info */}
            <Text
                size='xs'
                p='xs'
                color='dimmed'
                sx={(theme) => ({
                    borderBottom: theme.colorScheme === 'dark' ? `1px solid ${theme.colors.dark[5]}` : `1px solid ${theme.colors.gray[2]}`,
                })}>
                Total Sessions: {sessions.length}
                {/* | Sticky: {currentStickyHeader ? 'Active' : 'None'} */}
            </Text>

            <List
                ref={listRef}
                height={Math.max(400, window.innerHeight - 520)}
                itemCount={flattenedItems.length}
                itemSize={(index) => {
                    const item = flattenedItems[index];
                    return item?.type === 'session' ? 65 : 65;
                }}
                width='100%'
                onScroll={handleScroll}>
                {Row}
            </List>
            <StickyHeader />
        </Box>
    );
};

// <ScrollArea
//                                     h={390}
//                                     sx={(theme) => ({
//                                         border: theme.colorScheme === 'dark' ? `1px solid ${theme.colors.dark[5]}` : `1px solid ${theme.colors.gray[2]}`,
//                                         // backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
//                                         borderRadius: theme.radius.sm,
//                                         borderTopLeftRadius: 0,
//                                         borderTopRightRadius: 0,
//                                         // borderTop: 0,
//                                     })}>
//                                     {filteredStyles &&
//                                         filteredStyles.map((val, idx) => {
//                                             var backgroundColor = theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0];
//                                             var textColor = theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[9];
//                                             // if selected then backgroundColor = theme.colors.brand[4]
//                                             if (val && val.targetSort === form.values.styleNumber) {
//                                                 backgroundColor = theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.brand[4];
//                                                 textColor = theme.colorScheme === 'dark' ? theme.white : theme.colors.gray[9];
//                                             }
//                                             return (
//                                                 <React.Fragment key={idx}>
//                                                     {val ? (
//                                                         <UnstyledButton
//                                                             key={idx}
//                                                             onClick={() => onChangeHandler('styleNumber', val.targetSort)}
//                                                             sx={(theme) => ({
//                                                                 display: 'block',
//                                                                 width: '100%',
//                                                                 padding: theme.spacing.xs,
//                                                                 paddingTop: 7,
//                                                                 paddingBottom: 7,
//                                                                 borderBottomWidth: '1px',
//                                                                 borderBottomStyle: 'solid',
//                                                                 borderBottomColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2],
//                                                                 backgroundColor: backgroundColor,

//                                                                 '&:hover': {
//                                                                     backgroundColor: theme.colors.dark[4],
//                                                                     color: theme.colorScheme === 'dark' ? theme.white : theme.colors.gray[9],
//                                                                 },
//                                                             })}>
//                                                             <Group position='apart' noWrap>
//                                                                 <Box>
//                                                                     <Text size='sm' style={{ color: textColor }}>
//                                                                         {val?.targetSort}
//                                                                     </Text>
//                                                                     <Text size='xs' truncate style={{ color: textColor, opacity: 0.6, width: 200 }}>
//                                                                         {val.name}
//                                                                     </Text>
//                                                                 </Box>
//                                                                 <Badge>
//                                                                     <Group spacing={4}>
//                                                                         <IconCamera size={14} />
//                                                                         {val?.captures?.length}
//                                                                     </Group>
//                                                                 </Badge>
//                                                             </Group>
//                                                         </UnstyledButton>
//                                                     ) : null}
//                                                 </React.Fragment>
//                                             );
//                                         })}
//                                 </ScrollArea>

// <Stack spacing={0} sx={{ opacity: form.values.sessionId ? 1 : 0.5, maxHeight: form.values.sessionId ? '100%' : 0, overflow: 'hidden' }}>
// <FormInputWrapper label='Style' id='input-styleNumber' labelWidth={LABEL_WIDTH} direction='column'>
//     {/* want to show a large list of styles */}
//     <Box>
//         <Group mb={'xs'}>
//             <Box w='100%'>
//                 <TextInput
//                     rightSection={
//                         <ActionIcon opacity={keyword ? 1 : 0} onClick={() => setKeyword('')}>
//                             <IconX size={14} />
//                         </ActionIcon>
//                     }
//                     value={keyword}
//                     onChange={(e) => setKeyword(e.target.value)}
//                     sx={{ width: '100%', input: { borderBottomLeftRadius: 0, borderBottomRightRadius: 0 } }}
//                     placeholder='Filter Styles...'
//                     icon={<IconSearch size={14} />}
//                 />
//             </Box>
//             {/* <TextInput size='sm' color='dimmed' value={form.values.styleNumber} onChange={(e) => form.setFieldValue('styleNumber', e.target.value)} /> */}
//             {/* <Button variant='subtle' onClick={() => form.setFieldValue('styleNumber', '')}>
//             Clear
//         </Button> */}
//         </Group>

//     </Box>
//     {/* <Select
//     data={
//         styles && styles.length
//             ? styles.map((val) => {
//                   return { label: val.targetSort, value: val.targetSort };
//               })
//             : []
//     }
//     placeholder='All Style Numbers'
//     {...form.getInputProps('styleNumber')}
// /> */}
// </FormInputWrapper>
// {/* <Divider /> */}

// {/* <FormInputWrapper label='Season' id='input-location' labelWidth={LABEL_WIDTH}>
// <MultiSelect
// data={['React', 'Angular']}
// placeholder="All"

// />
// </FormInputWrapper> */}

// {/* <FormInputWrapper label='Colours' id='input-colours' labelWidth={LABEL_WIDTH}>
// <MultiSelect
// data={aggData?.colours?aggData.colours:[]}
// placeholder="All"

// />
// </FormInputWrapper> */}

// {/* <FormInputWrapper label='Machines' id='input-machines' labelWidth={LABEL_WIDTH}>
// <MultiSelect
//     data={
//         aggData?.machines
//             ? aggData.machines.map((val) => {
//                   return { label: val.split(':')[1], value: val };
//               })
//             : []
//     }
//     placeholder='All Machines'
//     {...form.getInputProps('machines')}
// />
// </FormInputWrapper> */}

// {/* <FormInputWrapper label='Sizes' id='input-sizes' labelWidth={LABEL_WIDTH}>
// <MultiSelect
// data={aggData?.sizes?aggData.sizes:[]}
// placeholder="All"

// />
// </FormInputWrapper> */}

// {/* <FormInputWrapper label='Location' id='input-location' labelWidth={LABEL_WIDTH}>
// <MultiSelect
// data={['React', 'Angular', 'Svelte', 'Vue']}
// placeholder="All"

// />
// </FormInputWrapper> */}

// {/* <FormInputWrapper label='SKU' id='input-sku' labelWidth={LABEL_WIDTH}>
// <MultiSelect
// data={['React', 'Angular', 'Svelte', 'Vue']}
// placeholder="All"
// />
// </FormInputWrapper> */}

// {/* <FormInputWrapper label='Tags' id='input-tags' labelWidth={LABEL_WIDTH}>
// <TagInput
//     {...form.getInputProps('tags')}
//     onChange={(val) => {
//         setTags([...val.map((item) => ({ value: item, label: item }))]);
//         form.setFieldValue('tags', val);
//     }}
// /> */}
// {/* <MultiSelect
//     data={tags}
//     searchable
//     creatable
//     // value={form.getInputProps('tags')}
//     getCreateLabel={(query) => `+ Create ${query}`}
//     onCreate={(query) => {
//         const item = { value: query, label: query };

//         setTags((current) => [...current, item]);

//         return item;
//     }}
//     placeholder='Type to enter Tags'
//     {...form.getInputProps('tags')}
// /> */}
// {/* </FormInputWrapper> */}

// {/* <FormInputWrapper label='Unassigned' id='input-rating' labelWidth={LABEL_WIDTH}>
// <Checkbox />
// </FormInputWrapper> */}
// <Group mt={'xl'} sx={{ width: '100%' }}>
//     <Button variant='outline' fullWidth onClick={() => clearFilter()}>
//         Clear Filters
//     </Button>
//     {/* <Button sx={{ flexGrow: 1 }} variant='filled' type='submit' onClick={onSubmit} loading={isSearching}>
//     {isSearching ? 'Please wait...' : 'Search'}
// </Button> */}
// </Group>
// </Stack>
